var Xhr = (function () {
    function Xhr() {
    }
    /*public getJSON(url, successHandler, errorHandler) {
     let xhr = new XMLHttpRequest();
     xhr.open('get', url, true);
     xhr.responseType = 'json';
     xhr.onload = function () {
     let status = xhr.status;
     if (status == 200) {
     successHandler && successHandler(xhr.response); // jshint ignore:line
     } else {
     errorHandler && errorHandler(status); // jshint ignore:line
     }
     };
     xhr.send()
     }*/
    // jshint ignore:start
    Xhr.prototype.getJSON = function (url, successHandler, errorHandler) {
        var xhr = typeof XMLHttpRequest != 'undefined'
            ? new XMLHttpRequest()
            : new ActiveXObject('Microsoft.XMLHTTP');
        xhr.open('get', url, true);
        xhr.onreadystatechange = function () {
            var status;
            var data;
            // https://xhr.spec.whatwg.org/#dom-xmlhttprequest-readystate
            if (xhr.readyState == 4) {
                status = xhr.status;
                if (status == 200) {
                    data = JSON.parse(xhr.responseText);
                    successHandler && successHandler(data);
                }
                else {
                    errorHandler && errorHandler(status);
                }
            }
        };
        xhr.send();
    };
    ;
    Xhr.prototype.sendJson = function (url, data, successHandler, errorHandler) {
        var xhr = typeof XMLHttpRequest != 'undefined'
            ? new XMLHttpRequest()
            : new ActiveXObject('Microsoft.XMLHTTP');
        xhr.open('post', url, true);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.onreadystatechange = function () {
            var status;
            if (xhr.readyState == 4) {
                status = xhr.status;
                if (status == 200) {
                    successHandler && successHandler(JSON.parse(xhr.responseText));
                }
                else {
                    errorHandler && errorHandler(JSON.parse(xhr.responseText));
                }
            }
        };
        xhr.send(JSON.stringify(data));
    };
    ;
    return Xhr;
}());
/**
 * Created by serdar.aglamis on 7.06.2017.
 */
var Cookie = (function () {
    function Cookie() {
    }
    Cookie.getCookie = function (name) {
        var value = "; " + document.cookie;
        var parts = value.split("; " + name + "=");
        if (parts.length == 2) {
            return parts.pop().split(";").shift();
        }
        else {
            return false;
        }
    };
    Cookie.setCookie = function (key, value, timestamp) {
        document.cookie = key + '=' + value + "; SameSite=None;secure" + '; expires=' + timestamp.toUTCString();
    };
    return Cookie;
}());
///<reference path="commons/xhr.ts" />
///<reference path="typings/jquery.d.ts" />
///<reference path="commons/cookie.ts" />
var commonController = (function () {
    function commonController() {
        this.scheduleUrl = "/action/tv_guide";
        this.scheduleImageServiceUrl = "//s.duhnet.tv/ps/teve2/98/738x415/";
        if (document.querySelector('#represantiveForm') !== null) {
            this.initRepresantativeFormListener();
        }
        if (document.querySelector('#wordGameForm') !== null) {
            //this.initWordGameFormListener();
            this.initWordGameFormListenerFormData();
        }
        if (document.querySelector('.section-live-play-detail') !== null) {
            this.scheduleUpdateListener();
        }
        if (!Cookie.getCookie('cookieAccepted')) {
            this.showCookiePolicy();
        }
    }
    commonController.prototype.showCookiePolicy = function () {
        var cookieElement = document.getElementById('cookiePolicy');
        if (cookieElement !== null) {
            cookieElement.style.display = "block";
            var closeButton = document.querySelector('.cookie-area .close-btn');
            closeButton.addEventListener('click', function () {
                var timestamp = new Date();
                var time = timestamp.getTime();
                time += 60 * 60 * 24 * 60 * 1000;
                timestamp.setTime(time);
                Cookie.setCookie('cookieAccepted', 'true', timestamp);
                cookieElement.style.display = "none";
            });
        }
    };
    commonController.prototype.scheduleUpdateListener = function () {
        var _this = this;
        setInterval(function () {
            _this.getCurrentSchedule();
        }, 600000);
    };
    commonController.prototype.getCurrentSchedule = function () {
        var _this = this;
        var xhr = new Xhr();
        var requestUrl = this.scheduleUrl;
        xhr.getJSON(requestUrl, function (data) {
            _this.updateScheduleBar(data);
        }, function (status) {
            console.log("YUKLEME HATASI");
        });
    };
    commonController.prototype.updateScheduleBar = function (data) {
        var programInfo = [
            {
                "time": data[0].StartTime.slice(11, 16),
                "title": data[0].Title
            },
            {
                "time": data[1].StartTime.slice(11, 16),
                "title": data[1].Title
            },
            {
                "time": data[2].StartTime.slice(11, 16),
                "title": data[2].Title
            },
            {
                "activeImage": this.scheduleImageServiceUrl + data[0].ContentId
            }
        ];
        document.querySelectorAll('.home-schedule-day .desc-wrapper .desc-time')[0].innerHTML = programInfo[0].time;
        document.querySelectorAll('.home-schedule-day .desc-wrapper .desc-program-name')[0].innerHTML = programInfo[0].title;
        document.querySelectorAll('.home-schedule-day .desc-wrapper .desc-time')[1].innerHTML = programInfo[1].time;
        document.querySelectorAll('.home-schedule-day .desc-wrapper .desc-program-name')[1].innerHTML = programInfo[1].title;
        document.querySelectorAll('.home-schedule-day .desc-wrapper .desc-time')[2].innerHTML = programInfo[2].time;
        document.querySelectorAll('.home-schedule-day .desc-wrapper .desc-program-name')[2].innerHTML = programInfo[2].title;
        var blurredBg = document.querySelector('.blurred-bg');
        blurredBg.style.background = "url('" + programInfo[3].activeImage + "')";
    };
    commonController.prototype.selectListAutoWidth = function () {
        $(document).ready(function () {
            if ($("#resizing_select")) {
                $("#width_tmp_option").html($('#resizing_select option:selected').text());
                $("#resizing_select").width($("#width_tmp_select").width() - 15);
            }
        });
    };
    commonController.prototype.initRepresantativeFormListener = function () {
        var formElement = $('#represantiveForm');
        var _this = this;
        formElement.validator().on('submit', function (e) {
            if (e.isDefaultPrevented()) {
                $("html, body").animate({ scrollTop: 0 }, "slow");
            }
            else {
                e.stopImmediatePropagation();
                e.preventDefault();
                var data = {
                    "Message": {
                        "Ad": $('#name').val(),
                        "Soyad": $('#surname').val(),
                        "Email": $('#email').val(),
                        "Doğum Tarihi": $('#birthdate').val(),
                        "İl": $('#city').val(),
                        "İlçe": $('#district').val(),
                        "Cinsiyet": $('#gender').val(),
                        "Yazma Nedeni": $('#reason').val(),
                        "Program Adı": $('#programs').val(),
                        "Yayın Tarihi": $('#broadcast-date').val(),
                        "Yayın Saati": $('#broadcast-time').val(),
                        "Mesajınız": $('#message').val()
                    }
                };
                data = JSON.stringify(data);
                $.ajax({
                    type: "POST",
                    url: "/action/send_contact_form",
                    data: data,
                    success: function (result) {
                        if (result === '{"result": true}') {
                            _this.formResultOperations(true, 'represantiveForm');
                        }
                        else {
                            _this.formResultOperations(false, 'represantiveForm');
                        }
                    }
                });
            }
        });
    };
    commonController.prototype.serializeObject = function (object) {
        var serializedObj = {};
        var arr = object.serializeArray();
        $.each(arr, function (index, elem) {
            if (serializedObj[elem.name] !== undefined) {
                if (!serializedObj[elem.name].push) {
                    serializedObj[elem.name] = [serializedObj[elem.name]];
                }
                serializedObj[elem.name].push(elem.value || '');
            }
            else {
                serializedObj[elem.name] = elem.value || '';
            }
        });
        return serializedObj;
    };
    commonController.prototype.getBase64 = function (file, callback) {
        var reader = new FileReader();
        if (typeof file !== 'undefined') {
            reader.onload = callback;
            reader.readAsDataURL(file);
        }
    };
    commonController.prototype.initWordGameFormListenerFormData = function () {
        var formElement = $('#wordGameForm'), _this = this;
        var loadingDiv = $('<div />', {
            "class": 'loading-block',
            title: 'Lütfen bekleyin...'
        });
        loadingDiv.html('Başvuru formunuz kayıt ediliyor, lütfen birkaç saniye bekleyiniz...');
        formElement.find('input:file').on('change', function () {
            $(this).parent().siblings('.placeholder-label').html(this.files[0].name);
        });
        formElement.on('submit', function (e) {
            e.stopImmediatePropagation();
            e.preventDefault();
            var formData = new FormData(this);
            loadingDiv.appendTo('body');
            $.ajax({
                url: 'https://form.teve2.com.tr/userforms',
                data: formData,
                type: "POST",
                crossDomain: true,
                contentType: false,
                processData: false,
                cache: false,
                timeout: 0
            }).done(function (data) {
                loadingDiv.remove();
                _this.formResultOperations(true, 'wordGameForm');
            }).fail(function () {
                loadingDiv.remove();
                _this.formResultOperations(false, 'wordGameForm');
            });
        });
    };
    commonController.prototype.formResultOperations = function (result, element) {
        $("html, body").animate({ scrollTop: 0 }, "slow");
        var formResult = $('#formResult');
        var submitBtn = $('#wordGameForm [type="submit"]');
        $(submitBtn).text('Gönder').removeAttr("disabled");
        if (element === 'represantiveForm') {
            formResult = $('#formResultModal');
            if (result) {
                document.getElementById(element).reset();
                formResult.find('.icon').removeClass('type-error');
                formResult.find('.icon').html("<img class=\"img-fluid\" src=\"" + formResult.attr('data-success-img') + "\" alt=\"\" />");
                formResult.find('.modal-title').text('Mesajınız Bize Ulaştı!');
                formResult.find('.modal-desc').html('<p>Görüş ve önerileriniz bizim için çok değerli.<br />İlginiz için teşekkür ederiz!</p>');
            }
            else {
                formResult.find('.icon').addClass('type-error');
                formResult.find('.icon').html("<img class=\"img-fluid\" src=\"" + formResult.attr('data-error-img') + "\" alt=\"\" />");
                formResult.find('.modal-title').text('Bir Hata Oluştu!');
                formResult.find('.modal-desc').html('<p>Mesajınız gönderilemedi. Lütfen tekrar deneyiniz.</p>');
            }
            formResult.modal('show');
        }
        else {
            formResult.show();
            formResult.removeClass('bg-danger').removeClass('bg-success');
            if (result) {
                formResult.addClass('bg-success');
                document.getElementById(element).reset();
                document.querySelector('.placeholder-label').innerHTML = '';
                formResult.text('Kaydınız başarıyla alınmıştır. Bizimle iletişime geçtiğiniz için teşekkür ederiz.');
            }
            else {
                formResult.addClass('bg-danger');
                formResult.text('Form Gönderilirken bir hata oluştu lütfen tekrar deneyiniz');
            }
            setTimeout(function () {
                formResult.fadeOut('fast');
            }, 5000);
        }
    };
    commonController.prototype.initNanoScrollers = function () {
        $(".desc-info.nano").nanoScroller({
            alwaysVisible: true
        });
        $(".playlist-container.nano").nanoScroller({
            alwaysVisible: true
        });
    };
    commonController.prototype.initLazyLoad = function () {
        $("img.lazy").unveil();
    };
    commonController.prototype.initReadMoreToggle = function () {
        $('.readmore').readmore({
            speed: 50,
            moreLink: '<a class="readmoreToggle" href="#">Daha Fazlası</a>',
            lessLink: '<a class="readmoreToggle" href="#">Açıklamayı Daralt</a>',
            embedCSS: false,
            collapsedHeight: 49
        });
    };
    commonController.prototype.initBdmp = function () {
        if (typeof bdmp !== 'function') {
            return;
        }
        var photoArea = $('.photo-area[data-image-count]');
        if (photoArea.length > 0) {
            var page = parseInt(photoArea.data('page') || 1);
            var imageCount = photoArea.data('imageCount');
            if (page == 1) {
                var galleryModel = { 'canonicalUrl': location.origin + location.pathname, 'quantity': imageCount };
                console.info('bdmp', galleryModel);
                bdmp('gallery', galleryModel);
            }
            var galleryViewModel = { 'canonicalUrl': location.origin + location.pathname, 'index': page };
            console.info('bdmp', galleryViewModel);
            bdmp('galleryView', galleryViewModel);
        }
    };
    /* autoHeightController() {
         setTimeout(function () {
             if($('.general-container').offset().top < 30) {
                 $('.masthead').css('height', 0);
             }
         }, 5000);
     }*/
    commonController.prototype.browserChecker = function () {
        if (navigator.appName == 'Microsoft Internet Explorer' || !!(navigator.userAgent.match(/Trident/) || navigator.userAgent.match(/rv 11/)) || /Edge/.test(navigator.userAgent)) {
            $('body').addClass('internet-explorer');
        }
    };
    commonController.prototype.initLightbox = function () {
        var lightbox = $('#lightbox-video');
        var lightboxHide = Cookie.getCookie('lightbox');
        var _saci = Cookie.getCookie('_saci');
        var _samr = Cookie.getCookie('_samr');
        var stats_api = false;
        if (_saci !== false)
            stats_api = true;
        else if (_samr !== false && _samr == "2")
            stats_api = true;
        // lightbox elementi yoksa || mobil cihazsa || cookie oluşmuşsa
        if (lightbox.length === 0 || window.outerWidth < 768 || lightboxHide !== false) {
            return false;
        }
        /*         lightbox.on('hidden.bs.modal', function (e) {
                    console.log('hidden.bs.modal');
                }); */
        /*
        lightbox.on('shown.bs.modal', function (e) {
            console.log('shown.bs.modal');
        }); */
        lightbox.modal('show');
        var timestamp = new Date();
        var time = timestamp.getTime();
        time += 60 * 60 * 24 * 1000;
        timestamp.setTime(time);
        Cookie.setCookie('lightbox', true, timestamp);
    };
    commonController.prototype.initHeader = function () {
        var navbar = $('.header .navbar');
        if (navbar.length > 0) {
            var navbarCollapse = navbar.find('#navbarResponsive');
            navbarCollapse.on('hide.bs.collapse', function () {
                navbar.removeClass('navbar-collapse');
            });
            navbarCollapse.on('show.bs.collapse', function () {
                navbar.addClass('navbar-collapse');
            });
        }
    };
    return commonController;
}());
var commons = new commonController();
commons.selectListAutoWidth();
commons.initNanoScrollers();
commons.initLazyLoad();
commons.initReadMoreToggle();
//commons.autoHeightController();
commons.browserChecker();
commons.initHeader();
$(document).ready(function () {
    commons.initLightbox();
    commons.initBdmp();
});
///<reference path="commons/xhr.ts" />
///<reference path="typings/jquery.d.ts" />
var InstantSearch = (function () {
    function InstantSearch() {
        this.searchUrl = "/action/suggest?q=";
        this.searchInput = document.getElementById('instant-search');
        this.ulNode = document.getElementById('search-result');
        this.markInstance = new Mark(document.querySelector(".context"));
        if (this.searchInput !== null) {
            this.setEventListener();
        }
    }
    InstantSearch.prototype.setEventListener = function () {
        var _this = this;
        this.searchInput.addEventListener("keyup", function () {
            $('.search-result').addClass('search-result-focused');
            if (this.value.length > 2) {
                _this.doSearchRequest(this.value);
            }
            else if (this.value.length === 0) {
                _this.clearSearchArea();
            }
            else {
                _this.clearSearchArea();
                var searchWarningNode = document.createElement('li');
                searchWarningNode.textContent = "Arama yapabilmek için en az üç karakter girmeniz gerekmektedir.";
                searchWarningNode.className = "warning";
                _this.ulNode.appendChild(searchWarningNode);
            }
        });
        window.addEventListener('click', function () {
            if (!$('#instant-search').is(':focus')) {
                $('.search-result').removeClass('search-result-focused');
                $('#instant-search').val('');
            }
        });
    };
    InstantSearch.prototype.doSearchRequest = function (value) {
        var _this = this;
        var xhr = new Xhr();
        var requestUrl = this.searchUrl + value;
        xhr.getJSON(requestUrl, function (data) {
            //alert('Sonuç' + data[0].Title);
            _this.setHtmlContent(data, value);
        }, function (status) {
            //alert('Birşeyler ters gitti');
        });
    };
    InstantSearch.prototype.setHtmlContent = function (data, value) {
        this.clearSearchArea();
        var _this = this;
        Object.keys(data).forEach(function (key) {
            var listNode = document.createElement('li');
            var linkNode = document.createElement('a');
            linkNode.textContent = data[key].Title;
            linkNode.setAttribute('href', data[key].Url);
            listNode.appendChild(linkNode);
            _this.ulNode.appendChild(listNode);
        });
        var moreListNode = document.createElement('li');
        var moreLinkNode = document.createElement('a');
        moreLinkNode.textContent = "> Daha Fazla Sonuç";
        moreLinkNode.setAttribute('href', '/arama?q=' + value);
        moreListNode.appendChild(moreLinkNode);
        _this.ulNode.appendChild(moreListNode);
        _this.markInstance.unmark().mark(value);
    };
    InstantSearch.prototype.clearSearchArea = function () {
        var _this = this;
        while (_this.ulNode.firstChild) {
            _this.ulNode.removeChild(_this.ulNode.firstChild);
        }
    };
    return InstantSearch;
}());
var search = new InstantSearch();
var LoadJS = (function () {
    function LoadJS() {
    }
    /*public getJSON(url, successHandler, errorHandler) {
     let xhr = new XMLHttpRequest();
     xhr.open('get', url, true);
     xhr.responseType = 'json';
     xhr.onload = function () {
     let status = xhr.status;
     if (status == 200) {
     successHandler && successHandler(xhr.response); // jshint ignore:line
     } else {
     errorHandler && errorHandler(status); // jshint ignore:line
     }
     };
     xhr.send()
     }*/
    // jshint ignore:start
    LoadJS.prototype.loadSync = function (file) {
        var element = document.createElement('script');
        element.src = file;
        element.setAttribute('async', 'true');
        document.body.appendChild(element);
    };
    return LoadJS;
}());
function tiakPlugin(options) {
    var that = this;
    var handle;
    var isPaused = false;
    var videoWidth = 0;
    var videoHeight = 0;
    var screenWidth = window.screen.width;
    var screenHeight = window.screen.height;
    options.channelID = options.channelID || 26;
    options.sitename = options.sitename || 'teve2-tr';
    options.tiakCategory = options.live ? 'teve2-live' : 'teve2-programs';
    var player = that;
    switch (options.pqType) {
        case 'Quark':
            player = that.player();
            break;
        case 'RadiantMP':
        case 'Dailymotion':
            player = that;
            break;
    }
    var getVideoDimensions = function () {
        switch (options.pqType) {
            case 'Quark':
                videoWidth = player.el_.clientWidth;
                videoHeight = player.el_.clientHeight;
                break;
            case 'RadiantMP':
                videoWidth = player.getPlayerWidth();
                videoHeight = player.getPlayerHeight();
                break;
            case 'Dailymotion':
                videoWidth = player.el_.clientWidth;
                videoHeight = player.el_.clientHeight;
                break;
        }
    };
    getVideoDimensions();
    var getPlayStates = function () {
        var playStates;
        switch (options.pqType) {
            case 'Dailymotion':
            case 'Quark':
                playStates = player.currentTime();
                break;
            case 'RadiantMP':
                playStates = options.live
                    ? (isPaused ? null : new Date().getTime() / 1000)
                    : player.getCurrentTime() / 1000;
                break;
            default:
                playStates = 0;
        }
        return playStates;
    };
    var handleResize = function () {
        var innerWidth = window.innerWidth, innerHeight = window.innerHeight;
        screenWidth = innerWidth;
        screenHeight = innerHeight;
        getVideoDimensions();
    };
    window.addEventListener("resize", handleResize);
    var playerIsLoaded = function () {
        var sensors = new SpringStreams(options.sitename);
        sensors.debug = function (v) {
            console.log("Request:", v);
        };
        window.addEventListener('teve2_unload', function (e) {
            sensors && sensors.unload();
        });
        var adapter = {
            getMeta: function () { return ({
                pl: options.pqType,
                plv: player.version,
                sx: videoWidth,
                sy: videoHeight
            }); },
            getPosition: getPlayStates,
            getDuration: function () { return options.live ? 0 : Math.round(player.duration()); }
        };
        var getDeviceTypeForTiak = function () {
            var ua = navigator.userAgent;
            if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
                return "tablet";
            }
            if (/Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
                return "mobile";
            }
            return "pc";
        };
        var deviceType = getDeviceTypeForTiak();
        var desc = {
            sx: screenWidth,
            sy: screenHeight,
            stream: options.live ? "live/" + options.channelID : "od/" + options.channelID,
            ct: deviceType ? deviceType : ''
        };
        if (!options.live) {
            desc['fbtime'] = options.broadcastScheduleTime;
        }
        player.subscribe('play', function () {
            isPaused = false;
        });
        player.subscribe('pause', function () {
            isPaused = true;
            sensors.doUpdate();
        });
        handle = sensors.track(options.tiakCategory, desc, adapter);
    };
    player.one('loadedmetadata', playerIsLoaded);
}
/// <reference path="typings/jquery.d.ts" />
/// <reference path="typings/quarkplayer.d.ts" />
///<reference path="commons/xhr.ts" />
///<reference path="commons/loadJS.ts" />
///<reference path="commons/cookie.ts" />
///<reference path="plugins/tiak/plugin.ts" />
var playersObject = (function () {
    function playersObject() {
        this.mediaRequestUrl = "/action/media/";
        this.geoBlockingUrl = "https://geoloc.hurriyet.com.tr/api/country";
        this.playerInstances = {};
        this.playlistVideos = [];
        this.createMedyanetPageSkin();
        this.videoAreaElement = document.getElementById("video-element");
        var lightboxElement = document.getElementById("lightbox-video");
        var lightboxHide = Cookie.getCookie("lightbox");
        var _this = this;
        if (lightboxElement !== null && lightboxHide === false && window.outerWidth >= 768) {
            _this.addQuarkPlayer();
            _this.elementOptions = {
                id: lightboxElement.dataset.id,
                showAds: (lightboxElement.dataset.ads === "true"),
                autoPlay: (lightboxElement.dataset.autoplay === "true"),
                viewability: (lightboxElement.dataset.viewability === "true") || true,
                live: (lightboxElement.dataset.live === "true"),
                techOrder: lightboxElement.dataset.live === "true" ? ['flash', 'html5'] : ['html5', 'flash'],
                adType: lightboxElement.dataset.adType,
                elementId: 'lightbox-player-container',
                originalName: lightboxElement.dataset.originalName,
                pqType: lightboxElement.dataset.pqType
            };
            _this.createMediaServiceQuery(_this.elementOptions);
        }
        if (this.videoAreaElement !== null) {
            /*            document.addEventListener('adservice-prebid-vasturl-prepared', (e: CustomEvent) => {
                            _this.adservicePrebidData = e.detail;
                        });*/
            this.checkGeoBlocking(function () {
                _this.addQuarkPlayer();
                _this.elementOptions = {
                    id: this.videoAreaElement.dataset.id,
                    showAds: (this.videoAreaElement.dataset.ads === "true"),
                    autoPlay: (this.videoAreaElement.dataset.autoplay === "true"),
                    embed: (this.videoAreaElement.dataset.embed !== undefined && (this.videoAreaElement.dataset.embed === "true" || this.videoAreaElement.dataset.embed === "True")),
                    embedUrl: location.protocol + '//' + location.host + '/embed' + this.videoAreaElement.dataset.url,
                    url: location.protocol + '//' + location.host + this.videoAreaElement.dataset.url,
                    slugurl: this.videoAreaElement.dataset.slugurl,
                    contentId: this.videoAreaElement.dataset.id,
                    tag: this.videoAreaElement.dataset.tag != null && this.videoAreaElement.dataset.tag.length > 0 ? this.videoAreaElement.dataset.tag : '',
                    maincat: this.videoAreaElement.dataset.maincat,
                    category: this.videoAreaElement.dataset.category,
                    playtype: this.videoAreaElement.dataset.playtype,
                    pubname: this.videoAreaElement.dataset.pubname,
                    isSpotVideo: "false",
                    viewability: (this.videoAreaElement.dataset.viewability === "true") || true,
                    live: (this.videoAreaElement.dataset.live === "true"),
                    techOrder: this.videoAreaElement.dataset.live === "true" ? ['flash', 'html5'] : ['html5', 'flash'],
                    adType: this.videoAreaElement.dataset.adType,
                    elementId: 'player-container',
                    logobrand: (this.videoAreaElement.dataset.logoBrand === "true"),
                    vendor: "TEVE2",
                    originalName: this.videoAreaElement.dataset.originalName,
                    pqType: this.videoAreaElement.dataset.pqType,
                    publishedDate: this.videoAreaElement.dataset.publishedDate,
                    broadcastScheduleTime: this.videoAreaElement.dataset.broadcastScheduleTime || ""
                };
                _this.createMediaServiceQuery(_this.elementOptions);
            }.bind(this));
        }
        this.playlistContainer = document.querySelector('.playlist-container');
        if (this.playlistContainer !== null) {
            this.createPlaylist(this.playlistContainer);
        }
    }
    playersObject.prototype.getQuarkPlayerVersion = function () {
        return document.body.dataset["playerVersion"];
    };
    playersObject.prototype.addQuarkPlayer = function () {
        var quarkPlayerVersion = this.getQuarkPlayerVersion();
        console.log("window.hasAdBlock", window.hasAdBlock);
        if (window.hasAdBlock) {
            document.querySelector('.player-warning.hidden').style.display = 'block';
        }
        else {
            var loadJS = new LoadJS();
            loadJS.loadSync('//imasdk.googleapis.com/js/sdkloader/ima3.js?v=1');
            loadJS.loadSync('https://player.teve2.com.tr/q/s/player/html5/' + quarkPlayerVersion + '/assets/js/docs.min.js');
        }
    };
    playersObject.prototype.createMedyanetPageSkin = function () {
        window.Medyanet_Pageskin = function (pageskin) {
            var pageskinHtml = '<a href="' + pageskin.ClickUrl + '" target="_blank" class="hidden-md-down">' +
                '<img src="' + pageskin.CreativeSource + '">' +
                '</a>' +
                '<a href="' + pageskin.ClickUrl + '" target="_blank" class="hidden-lg-up">' +
                '<img src="' + pageskin.CreativeSourceMobile + '">' +
                '</a>' +
                '<img src="' + pageskin.ImpresssionUrl + '" style="position: absolute; width: 1px; height: 1px;">';
            if (pageskin.ImpresssionTrackingUrl) {
                pageskinHtml += '<img src="' + pageskin.ImpresssionTrackingUrl + '" style="position: absolute; width: 1px; height: 1px;">';
            }
            document.querySelector('.page-skin').innerHTML = pageskinHtml;
        };
    };
    playersObject.prototype.createMediaServiceQuery = function (options) {
        options.id = options.id.replace('/', '');
        var _this = this;
        var xhr = new Xhr();
        var requestUrl = this.mediaRequestUrl + options.id;
        xhr.getJSON(requestUrl, function (data) {
            if (data.Status === 'Success') {
                if (typeof data && data.Media && data.Media.Image !== 'undefined') {
                    options.poster = data.Media.Image + '.jpg';
                }
                else {
                    options.poster = '';
                }
                if (data.Media.Link.ServiceUrl) {
                    options.source = {
                        src: data.Media.Link.ServiceUrl + '/' + data.Media.Link.SecurePath,
                        type: 'application/x-mpegURL'
                    };
                }
                else {
                    options.source = {
                        src: (data.Media.Link.SecurePath.indexOf('http') > -1 ? '' : 'https://teve2.duhnet.tv') + (data.Media.Link.SecurePath.indexOf('/') === 0 || data.Media.Link.SecurePath.indexOf('http') > -1 ? data.Media.Link.SecurePath : '/' + data.Media.Link.SecurePath),
                        type: data.Media.Link.SecurePath.indexOf('.mp4') > -1 ? 'video/mp4' : 'application/x-mpegURL'
                    };
                }
                var url = new URL(options.source.src);
                var maxMin = 'min=0&max=2500';
                if ((window.innerWidth < 768)) {
                    maxMin = 'min=0&max=1250';
                }
                var live = options.live === "true" ? '&live=true' : '';
                var app = '&app=com.tv2';
                // query string de bişeyler varsa
                if (url.search.indexOf('?') > -1) {
                    maxMin = "&" + maxMin;
                }
                else {
                    maxMin = "?" + maxMin;
                }
                options.source.src = options.source.src + maxMin + live + app;
                options.UserName = data.User.Name;
                options.SessionId = data.User.SessionId;
                var initQuarkPlayer = function () {
                    if (typeof QuarkPlayer !== 'undefined') {
                        if (typeof googlefc !== 'undefined' && window.location.host.indexOf("local") === -1) {
                            googlefc.callbackQueue.push({
                                'CONSENT_DATA_READY': function () { return _this.createQuarkInstance(options); }
                            });
                        }
                        else {
                            _this.createQuarkInstance(options);
                        }
                    }
                };
                setTimeout(initQuarkPlayer, 500);
            }
            else {
            }
        }, function (status) {
            //alert('Birşeyler ters gitti');
        });
    };
    playersObject.prototype.createQuarkInstance = function (elementOptions) {
        var embedAdType = "embed";
        if (document.referrer.indexOf('hurriyet.com') > -1 || document.referrer.indexOf('milliyet.com') > -1 ||
            document.referrer.indexOf('posta.com') > -1 || document.referrer.indexOf('fanatik.com') > -1 ||
            document.referrer.indexOf('fanatik.com') > -1 || document.referrer.indexOf('dreamtv.com') > -1 ||
            document.referrer.indexOf('dreamturk.com') > -1 || document.referrer.indexOf('cnnturk.com') > -1 ||
            document.referrer.indexOf('radyod.com') > -1 || document.referrer.indexOf('kanald.com') > -1 ||
            document.referrer.indexOf('vatan.com') > -1 || document.referrer.indexOf('netd.com') > -1 || document.referrer.indexOf('teve2') > -1) {
            embedAdType = "DEmbed";
        }
        console.log('ELEMENT OPTIONS', elementOptions);
        var cookies = Cookie.getCookie("M_BK");
        var options = {
            id: elementOptions.elementId,
            materialId: elementOptions.id,
            broadcastScheduleTime: elementOptions.broadcastScheduleTime || "",
            debug: false,
            techOrder: ['html5'],
            autoPlay: elementOptions.autoPlay,
            viewability: elementOptions.viewability || true,
            showAds: elementOptions.showAds,
            embedUrl: location.protocol + '//' + location.host + '/embed' + elementOptions.url,
            url: location.protocol + '//' + location.host + elementOptions.url,
            slugurl: elementOptions.slugurl,
            embed: elementOptions.embed,
            contentId: elementOptions.id,
            category: elementOptions.category,
            tag: elementOptions.tag,
            pubname: elementOptions.pubname,
            maincat: elementOptions.maincat,
            playtype: elementOptions.playtype,
            isSpotVideo: elementOptions.isSpotVideo,
            showNotification: false,
            showBandwidthSelector: true,
            customMenu: true,
            live: elementOptions.live,
            originalName: elementOptions.originalName,
            pqType: elementOptions.pqType,
            publishedDate: elementOptions.publishedDate,
            poster: elementOptions.poster,
            sources: [elementOptions.source],
            subTitles: null,
            playsinline: true,
            // Birden çok targetı bir arada kullanabilmek için VMAP kullanılmalıdır. VMAP açıklamasına dökümandan ulaşılabilir
            adTagUrl: window.location.origin + '/action/vmap?id=' + elementOptions.id + (elementOptions.adType ? '&adType=' + elementOptions.adType : '') + '&embedAdType=' + embedAdType + "&plcmt=1",
            plugins: [playerEvent, AdsManagerPlugin, BdmpPlugin, tiakPlugin],
            stats: {
                gemius: {
                    identifier: "dw.q8cb623JEXnnyE2dkL6PeHUvu8Ucmwu8LvtsUIzD.47"
                },
                comscore: {
                    c1: "1",
                    c2: "9053247",
                    c3: "TV2"
                }
            },
            ima: {
                adWillAutoPlay: elementOptions.autoPlay
            },
            hlsCustomBandwithSelector: function () {
                this.on('loadedmetadata', function () {
                    var player = this;
                    var levels = [{
                            speed: 9999,
                            text: 'Otomatik',
                            index: -1
                        }];
                    var levelTextMap = {
                        500: '360p',
                        1000: '480p',
                        1500: '720p'
                    };
                    // 1080p mobilde görünmeyecek
                    if (!(window.innerWidth < 768)) {
                        levelTextMap[2500] = '1080p';
                    }
                    this.hlsjs.levels.forEach(function (level, index) {
                        level.url.forEach(function (url) {
                            var matched = url.match(/\/\d+\//);
                            if (matched) {
                                var speed = parseInt(matched[0].replace(/\//g, ''));
                                if (typeof levelTextMap[speed] !== 'undefined') {
                                    levels.push({
                                        speed: speed,
                                        text: levelTextMap[speed],
                                        index: index
                                    });
                                }
                            }
                        });
                    });
                    levels.sort(function (a, b) { return b.speed - a.speed; });
                    if (levels.length) {
                        // set best quality to current level
                        player.hlsjs.currentLevel = levels[0].index;
                        var $container = document.createElement('div');
                        $container.setAttribute('id', 'bandwidth-selector');
                        $container.setAttribute('class', 'vjs-settings-button vjs-menu-button vjs-menu-button-popup vjs-control vjs-icon-cog');
                        var $menu = document.createElement('div');
                        $menu.setAttribute('class', 'vjs-menu');
                        $container.appendChild($menu);
                        var $content_1 = document.createElement('ul');
                        $content_1.setAttribute('class', 'vjs-menu-content');
                        $menu.appendChild($content_1);
                        levels.forEach(function (level, index) {
                            var $quality = document.createElement('li');
                            $quality.setAttribute('class', 'vjs-menu-item');
                            if (index === 0) {
                                $quality.classList.add('vjs-selected');
                            }
                            $quality.addEventListener('click', function () {
                                var $selected = $content_1.querySelector('.vjs-selected');
                                if ($selected) {
                                    $selected.classList.remove('vjs-selected');
                                }
                                $quality.classList.add('vjs-selected');
                                player.hlsjs.currentLevel = level.index;
                            });
                            $quality.innerText = level.text;
                            $content_1.appendChild($quality);
                        });
                        this.controlBar.el_.insertBefore($container, this.controlBar.fullscreenToggle.el_);
                    }
                });
            }
        };
        if (this.adservicePrebidData && this.adservicePrebidData.vastUrls && this.adservicePrebidData.vastUrls.length > 0 && this.adservicePrebidData.playerId === elementOptions.elementId) {
            var offsets_1 = {
                preroll: 'start',
                midroll: '00:00:15.000',
                postroll: 'end'
            };
            var adTags = this.adservicePrebidData.vastUrls.map(function (vastUrl) {
                return {
                    id: vastUrl.type,
                    type: 'linear',
                    url: vastUrl.vastUrl,
                    offset: offsets_1[vastUrl.type]
                };
            });
            options['adTagUrl'] = null;
            options['adTags'] = adTags;
        }
        var prepareLabel = function (data) {
            var result = '';
            result += 'VEmbedUrl:' + data.embedUrl + '|';
            result += 'VUrl:' + data.url + '|';
            result += 'VSlugTitle:' + data.slugurl + '|';
            result += 'VContentId:' + data.contentId + '|';
            result += 'VMainCat:' + data.maincat + '|';
            result += 'VCat:' + data.category + '|';
            result += 'VTags:' + data.tag + '|';
            result += 'VIsSpotVideo:' + data.isSpotVideo + '|';
            result += 'VPlayType:' + data.playtype + '|';
            result += 'PubName:' + data.pubname;
            return result;
        };
        if (elementOptions.logobrand === true) {
            options["logobrand"] = {
                image: "https://s.teve2.com.tr/assets/img/player_button.png",
                destination: "https://www.teve2.com.tr/"
            };
        }
        var _this = this;
        _this.playerInstances[elementOptions.id] = new QuarkPlayer(options);
        _this.playerInstances[elementOptions.id].player.on('allended', function (e) {
            _this.similarVideosOptions();
        });
        _this.playerInstances[elementOptions.id].player.on('ads-manager-all-ads-completed', function (e) {
            _this.videoEndedPlaylistHandler();
        });
        _this.playerInstances[elementOptions.id].player.on('play', function (e) {
            var _this = this;
            if (!this.analyticsTriggered) {
                _this.analyticsTriggered = true;
                try {
                    ga('send', 'event', 'Videos', 'play', window.location.pathname);
                    if (playerObjects.elementOptions.embed) {
                        ga('send', {
                            hitType: 'event',
                            eventCategory: 'VMS',
                            eventAction: 'Started',
                            eventLabel: prepareLabel(playerObjects.elementOptions)
                        });
                    }
                }
                catch (err) {
                }
            }
        });
        var lightbox = $('#lightbox-video');
        if (lightbox.length != 0) {
            lightbox.on('hidden.bs.modal', function (e) {
                if (_this.playerInstances[elementOptions.id].options.id == "lightbox-player-container") {
                    _this.playerInstances[elementOptions.id].dispose();
                }
            });
        }
    };
    playersObject.prototype.similarVideosOptions = function () {
        var _this = this;
        var similarVideosWrapper = $('#similar-videos-wrapper');
        if (similarVideosWrapper.length) {
            var upNextElement_1 = $('#similar-videos-wrapper .up-next');
            similarVideosWrapper.removeClass('hidden-xs-up');
            var seconds_1 = 8;
            var count = $('#similar-videos-wrapper .similar-videos a').length;
            var item = $('#similar-videos-wrapper .similar-videos a').eq(0);
            if (item && item.attr('href') !== undefined) {
                upNextElement_1.find('h2').html(item.attr('title'));
                upNextElement_1.find('img').attr('src', item.data('image'));
                _this.similarInterval = setInterval(function () {
                    seconds_1--;
                    if (seconds_1 < 0) {
                        clearInterval(_this.similarInterval);
                        var nextLink = $('.up-next-loader').attr('href');
                        window.location.href = nextLink;
                    }
                }, 1000);
            }
            document.getElementById("cancel-upnext").addEventListener("click", function () {
                clearInterval(_this.similarInterval);
                upNextElement_1.addClass('hidden-xs-up');
            });
        }
    };
    playersObject.prototype.checkGeoBlocking = function (callback) {
        var _this = this;
        _this.isGeoBlockingActive = _this.videoAreaElement.dataset.geoBlocking == 'true';
        _this.geoBlockingCountries = _this.videoAreaElement.dataset.geoBlockingCountries
            ? _this.videoAreaElement.dataset.geoBlockingCountries.split(',').filter(function (i) { return i; })
            : false;
        if (_this.isGeoBlockingActive && _this.geoBlockingCountries) {
            $.ajax({
                type: "GET",
                url: _this.geoBlockingUrl,
                success: function (data, textStatus, jqXHR) {
                    if (data
                        && data.hasOwnProperty('CountryCode')
                        && _this.geoBlockingCountries.includes(data.CountryCode)) {
                        _this.videoAreaElement.classList.add("geo-blocking");
                    }
                    else {
                        callback();
                    }
                },
                error: function () {
                    callback();
                }
            });
        }
        else {
            callback();
        }
    };
    playersObject.prototype.createPlaylist = function ($container) {
        var _this = this;
        $container.querySelectorAll('a[data-id]').forEach(function (element) {
            // sonraki videoya geçmede kullanmak için saklıyoruz
            _this.playlistVideos.push(element.getAttribute('data-id'));
            element.addEventListener('click', function (event) {
                event.preventDefault();
                var activeId = _this.elementOptions.id;
                var nextId = element.getAttribute('data-id');
                var metaData = {
                    title: element.getAttribute('data-title'),
                    description: element.getAttribute('data-description'),
                    backgroundImage: element.getAttribute('data-background')
                };
                console.log('playlistItem', activeId);
                _this._playlistNextVideo(activeId, nextId, metaData);
            });
        });
    };
    playersObject.prototype.videoEndedPlaylistHandler = function () {
        var playlistContainer = this.playlistContainer;
        if (!playlistContainer) {
            return false;
        }
        if (!this.playlistVideos.length) {
            return false;
        }
        var activePlayerIndex = this.playlistVideos.indexOf(this.elementOptions.id);
        if (activePlayerIndex < 0) {
            activePlayerIndex = 0;
        }
        var nextIndex = activePlayerIndex + 1;
        if (nextIndex !== this.playlistVideos.length) {
            var activeId = this.elementOptions.id;
            var nextId = this.playlistVideos[nextIndex];
            var element = playlistContainer.querySelector('a[data-id="' + nextId + '"]');
            var metaData = {
                title: element.getAttribute('data-title'),
                description: element.getAttribute('data-description'),
                backgroundImage: element.getAttribute('data-background')
            };
            this._playlistNextVideo(activeId, nextId, metaData);
        }
    };
    playersObject.prototype._playlistNextVideo = function (activeId, nextId, metaData) {
        // şu an oynayan playerı durdur
        this.playerInstances[activeId].dispose();
        // tıklanan playerı oynat
        this.elementOptions.id = nextId;
        this.createMediaServiceQuery(this.elementOptions);
        // playerın altındaki title, description vs güncelle
        var player = this.playlistContainer.querySelector('.player');
        player.querySelector('#video-element').setAttribute('data-id', nextId);
        player.querySelector('.desc-title').innerText = metaData.title;
        player.querySelector('.desc-info .nano-content').innerText = metaData.description;
        var shareInput = this.playlistContainer.querySelector('#input-iframe-code');
        var playlistSection = document.querySelector('.section-video-playlist-detail');
        var blurredBg = playlistSection.querySelector('.blurred-bg');
        if (playlistSection !== null) {
            playlistSection.setAttribute('data-share-image', metaData.backgroundImage);
        }
        if (blurredBg !== null) {
            blurredBg.style.backgroundImage = "url(" + metaData.backgroundImage + ")";
        }
        if (shareInput !== null) {
            shareInput
                .setAttribute('value', "<iframe src=\"https://teve2.com.tr/embed/" + nextId + "\" width=560 height=315 frameborder=0 allowfullscreen></iframe>");
        }
    };
    return playersObject;
}());
function AdsManagerPlugin() {
    var player = this;
    var ADS_STATE = {
        IS_ADS_PLAYING: false,
        IS_ADS_INITIALIZED: false
    };
    this.on("adsready", function () {
        ADS_STATE.IS_ADS_INITIALIZED = true;
        var adsManager = this.ima.getAdsManager();
        adsManager.addEventListener(google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED, function () {
            ADS_STATE.IS_ADS_PLAYING = true;
            player.trigger("ads-manager-ads-started", true);
        });
        adsManager.addEventListener(google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED, function () {
            ADS_STATE.IS_ADS_PLAYING = false;
            player.trigger("ads-manager-ads-finished");
        });
        adsManager.addEventListener(google.ima.AdEvent.Type.USER_CLOSE, function () {
            ADS_STATE.IS_ADS_PLAYING = false;
            player.trigger("ads-manager-ads-finished");
        });
        adsManager.addEventListener(google.ima.AdEvent.Type.STARTED, function (event) {
            var ad = event.getAd();
            if (!ad.isLinear()) {
                ADS_STATE.IS_ADS_PLAYING = true;
                player.trigger("ads-manager-ads-started", false);
                var minSuggestedDuration = ad.getMinSuggestedDuration();
                if (minSuggestedDuration > 0) {
                    setTimeout(function () {
                        ADS_STATE.IS_ADS_PLAYING = false;
                        player.trigger("ads-manager-ads-finished");
                    }, minSuggestedDuration * 1000);
                }
            }
        });
    });
    this.one("ended", function () {
        if (!ADS_STATE.IS_ADS_INITIALIZED) {
            player.trigger("ads-manager-all-ads-completed");
        }
        else {
            var timeoutCount_1 = 0;
            var timeoutMax_1 = 10;
            var timeoutInterval_1 = setInterval(function () {
                timeoutCount_1++;
                if (timeoutCount_1 >= timeoutMax_1) {
                    clearInterval(timeoutInterval_1);
                    player.trigger("ads-manager-all-ads-completed");
                }
                if (ADS_STATE.IS_ADS_PLAYING) {
                    clearInterval(timeoutInterval_1);
                    var finishedCount_1 = 0;
                    var finishedMax_1 = 300;
                    var finishedInterval_1 = setInterval(function () {
                        finishedCount_1++;
                        if (finishedCount_1 >= finishedMax_1) {
                            clearInterval(finishedInterval_1);
                            player.trigger("ads-manager-all-ads-completed");
                        }
                        if (!ADS_STATE.IS_ADS_PLAYING) {
                            clearInterval(finishedInterval_1);
                            player.trigger("ads-manager-all-ads-completed");
                        }
                    }, 200);
                }
            }, 300);
        }
    });
    this.on("dispose", function () {
        this.off("ads-manager-all-ads-completed");
        this.off("ads-manager-ads-started");
        this.off("ads-manager-ads-finished");
    });
}
function playerEvent(options) {
    var player = this;
    this.subscribe = function (event, callback) {
        if (event && callback) {
            player.on(event, callback);
        }
    };
}
function BdmpPlugin(options) {
    if (typeof bdmp !== 'function') {
        console.error('bdmp is not defined.');
        return;
    }
    var _player = this;
    var _options = options;
    var playTimeInterval = null;
    // Video meta data yüklendiğinde
    // model oluşturacak data elde edebiliyoruz.
    this.on("loadedmetadata", function () {
        if (!_options.publishedDate) {
            return;
        }
        // Video ilk başladığı zaman
        // video event'ı gönderilir.
        var bdmpModel = {
            'videoIdentifier': _options.materialId,
            'videoDisplayUrl': location.origin + location.pathname,
            'videoPosterUrl': _options.poster,
            'videoPublishedDate': parseInt(_options.publishedDate),
            'videoDuration': parseInt(_player.duration()),
            'videoLabel': _options.originalName
        };
        console.info('bdmp', bdmpModel);
        bdmp('video', bdmpModel);
        // Video oyanıtıldığı sürece,
        // X saniyede bir videoTrack event'ı gönderilir.
        _player.on('playing', function () {
            if (!playTimeInterval) {
                playTimeInterval = setInterval(function () {
                    var bdmpModel = {
                        'videoIdentifier': _options.materialId,
                        'videoDisplayUrl': location.origin + location.pathname,
                        'videoCurrentTime': parseInt(_player.currentTime())
                    };
                    console.info('bdmp', bdmpModel);
                    bdmp('videoTrack', bdmpModel);
                }, 10 * 1000);
            }
        });
        // Video oyanıtıldığı durdurulduğunda,
        // videoTrack event'ı gönderilmesi de durdurulur.
        _player.on('pause', function () {
            if (playTimeInterval) {
                clearInterval(playTimeInterval);
                playTimeInterval = null;
            }
        });
    });
}
var playerObjects = new playersObject();
/// <reference path="typings/jquery.d.ts" />
/// <reference path="typings/quarkplayer.d.ts" />
///<reference path="commons/xhr.ts" />
var Share = (function () {
    function Share() {
        this.fbAppId = "1701078970182449";
        this.twitterUsername = "teve2Official";
        this.baseDomain = "https://www.teve2.com.tr";
        if (document.querySelector('.section-photo-gallery-detail') !== null) {
            this.photoGalleryShareListener();
        }
        if (document.querySelector('.section-video-play-detail') !== null || document.querySelector('.section-video-playlist-detail') !== null) {
            this.videoDetailListener();
        }
    }
    Share.prototype.photoGalleryShareListener = function () {
        var _this = this;
        var facebookElements = document.querySelectorAll('.social-media-blocks .icon-facebook');
        var twitterElements = document.querySelectorAll('.social-media-blocks .icon-x');
        var title = document.querySelector('.desc-wrapper .desc-title').textContent;
        var description = document.querySelector('.nano-content').textContent;
        var url = this.baseDomain + window.location.pathname;
        var picElement = document.querySelector('.section-photo-gallery-detail');
        var picture = picElement.dataset.shareImage;
        picture = "http:" + picture;
        /* jshint ignore:start */
        for (var i = 0; i < facebookElements.length; i++) {
            facebookElements[i].addEventListener("click", function () {
                _this.facebookShare(title, description, url, picture);
            });
        }
        for (var t = 0; t < twitterElements.length; t++) {
            twitterElements[t].addEventListener("click", function () {
                _this.twitterShare(title);
            });
        }
        /* jshint ignore:end */
    };
    Share.prototype.videoDetailListener = function () {
        var _this = this;
        var facebookElements = document.querySelectorAll('.social-media-blocks .icon-facebook');
        var twitterElements = document.querySelectorAll('.social-media-blocks .icon-x');
        var embedCopyButtons = document.querySelectorAll('.embed-copy-button');
        var title = document.querySelector('.desc-wrapper .desc-title').textContent;
        var description = "";
        if (embedCopyButtons.length != 0) {
            var copyFunction = function (value) {
                var input_temp = document.createElement("input");
                input_temp.value = value;
                document.body.appendChild(input_temp);
                input_temp.select();
                document.execCommand("copy");
                document.body.removeChild(input_temp);
            };
            var copiedEmbedUrl_1 = document.getElementById('input-iframe-code').value;
            var copyButtonTexts_1 = document.querySelectorAll('.embed-copy-button > span');
            var icons_1 = document.querySelectorAll('.embed-copy-button > .icon');
            var _loop_1 = function (i) {
                embedCopyButtons[i].addEventListener('click', function () {
                    copyFunction(copiedEmbedUrl_1);
                    icons_1[i].classList.remove('icon-copy');
                    icons_1[i].classList.add('icon-checkmark');
                    embedCopyButtons[i].classList.add('copied');
                    copyButtonTexts_1[i].textContent = "KOPYALANDI";
                    setTimeout(function () {
                        embedCopyButtons[i].classList.remove('copied');
                        copyButtonTexts_1[i].textContent = "KOPYALA";
                        icons_1[i].classList.remove('icon-checkmark');
                        icons_1[i].classList.add('icon-copy');
                    }, 3000);
                });
            };
            for (var i = 0; i < embedCopyButtons.length; i++) {
                _loop_1(i);
            }
        }
        if (document.querySelector('.nano-content p') !== null) {
            description = document.querySelector('.nano-content p').textContent;
        }
        else if (document.querySelector('.desc-info.readmore') !== null) {
            description = document.querySelector('.desc-info.readmore').textContent;
        }
        var url = this.baseDomain + window.location.pathname;
        var picElement = document.querySelector('.section-video-play-detail');
        if (picElement === null) {
            picElement = document.querySelector('.section-video-playlist-detail');
        }
        var picture = picElement.dataset.shareImage;
        picture = "http:" + picture;
        /* jshint ignore:start */
        for (var i = 0; i < facebookElements.length; i++) {
            facebookElements[i].addEventListener("click", function () {
                _this.facebookShare(title, description, url, picture);
            });
        }
        for (var t = 0; t < twitterElements.length; t++) {
            twitterElements[t].addEventListener("click", function () {
                _this.twitterShare(title);
            });
        }
        /* jshint ignore:end */
        $('.social-media-blocks .icon-embed').on('click', function (ev) {
            ev.preventDefault();
            $(this).parent().find('.share-embed-url').toggleClass('show');
        });
        $(document).on('click', function (e) {
            if (!$(e.target).closest('.share-embed-url').length && !$(e.target).closest('.icon-embed').length) {
                $('.share-embed-url').removeClass('show');
            }
        });
    };
    Share.prototype.facebookShare = function (title, description, url, picture) {
        var shareProto = "https://www.facebook.com/dialog/feed?app_id=" +
            this.fbAppId +
            "&display=popup&link=" +
            url +
            "&redirect_uri=" +
            url +
            "&title=" +
            title +
            "&description=" +
            description +
            "&picture=" +
            picture;
        window.open(shareProto, 'facebook', 'toolbar=0,status=0,width=650,height=436');
        return false;
    };
    Share.prototype.twitterShare = function (text) {
        var shareProto = "https://twitter.com/intent/tweet?via=" +
            this.twitterUsername +
            "&text=" +
            text + window.location.href;
        window.open(shareProto, 'twitter', 'toolbar=0,status=0,width=650,height=436');
        return false;
    };
    return Share;
}());
var share = new Share();
/// <reference path="typings/swiper.d.ts" />
/// <reference path="typings/jquery.d.ts" />
/// <reference path="commons/xhr.ts" />
/// <reference path="commons/loadJS.ts" />
/// <reference path="commons/cookie.ts" />
var Story = (function () {
    function Story() {
        var _this = this;
        this.quarkPlayerIds = [];
        this.swiperVideos = null;
        this.elements = {
            popup: document.querySelector('.popup-story'),
            container: document.querySelector('.story-slider-container[class*="slider"]'),
            avatars: document.querySelectorAll('.popup-story-avatar .swiper-slide')
        };
        if (this.elements.popup && this.elements.container) {
            this.elements.storyCards = this.elements.container.querySelectorAll('.story-slider-container .swiper-slide');
            this.init();
        }
        this.storyPlayer = new StoryPlayer(function () {
            _this.swiperVideos.slideNext();
        });
    }
    Story.prototype.init = function () {
        this.initThumbnailsSwiper();
        this.popupOpenClickHandler();
        this.storyCardClickHandler();
        this.progressBarAdjustments();
        this.avatarsClickHandler();
    };
    Story.prototype.initThumbnailsSwiper = function () {
        new Swiper(this.elements.container, {
            preloadImages: false,
            lazyLoading: {
                loadPrevNext: true,
                loadPrevNextAmount: 1
            },
            slidesPerView: 4,
            slidesPerColumn: 1,
            spaceBetween: 16,
            pagination: '.swiper-pagination',
            nextButton: '.swiper-button-next',
            prevButton: '.swiper-button-prev',
            slidesPerGroup: 4,
            freeMode: true,
            paginationClickable: true,
            simulateTouch: true,
            slidesPerColumnFill: 'row',
            breakpoints: {
                992: {
                    slidesPerView: 3.5,
                    simulateTouch: false,
                    slidesPerColumn: 1,
                    spaceBetween: 20
                },
                758: {
                    slidesPerView: 4.5,
                    simulateTouch: true,
                    freeMode: true,
                    slidesPerColumn: 1,
                    spaceBetween: 15
                }
            }
        });
    };
    Story.prototype.initSwipers = function (initialSlide) {
        var _this = this;
        var popup = this.elements.popup;
        if (!this.swiperVideos) {
            var swiperVideos = popup.querySelector('.popup-story-videos');
            this.swiperVideos = new Swiper(swiperVideos, {
                preloadImages: false,
                lazyLoading: {
                    lazyLoadingInPrevNext: true,
                    lazyLoadingInPrevNextAmount: 2
                },
                watchSlidesVisibility: true,
                slidesPerView: 'auto',
                simulateTouch: false,
                centeredSlides: true,
                loop: false,
                slidesPerGroup: 1,
                slideToClickedSlide: true,
                cube: {
                    slideShadows: true
                },
                paginationClickable: true,
                spaceBetween: 70,
                initialSlide: initialSlide,
                onInit: function () {
                    var spaceLeftEl = _this.elements.popup.querySelector(".space.first");
                    var spaceRightEl = _this.elements.popup.querySelector(".space.last");
                    var hit = (window.innerWidth - document.querySelector('.popup-story-videos .swiper-slide').offsetWidth) / 2;
                    var avatarItemWidth = _this.elements.avatars[0].offsetWidth;
                    if (window.innerWidth > 768) {
                        spaceLeftEl.style.maxWidth = Math.ceil(hit) + "px";
                        spaceRightEl.style.maxWidth = Math.ceil((window.innerWidth - hit) - avatarItemWidth) + "px";
                    }
                },
                breakpoints: {
                    991: {
                        spaceBetween: 15,
                        direction: 'vertical',
                        centeredSlides: false,
                        simulateTouch: true,
                        watchSlidesVisibility: false
                    }
                }
            });
            this.avatarSetActiveAndScroll(this.swiperVideos.slides[initialSlide].getAttribute('data-target-avatar'));
            var prev = swiperVideos.querySelector('.shadow-navigation-prev'), next = swiperVideos.querySelector('.shadow-navigation-next');
            prev.addEventListener('click', function () {
                _this.swiperVideos.slidePrev();
            });
            next.addEventListener('click', function () {
                _this.swiperVideos.slideNext();
            });
            this.swiperVideos.on('slideChangeStart', function () {
                _this.storyPlayer.play(_this.swiperVideos.slides[_this.swiperVideos.activeIndex]);
                _this.avatarSetActiveAndScroll(_this.swiperVideos.slides[_this.swiperVideos.activeIndex].getAttribute('data-target-avatar'));
            });
        }
        else {
            this.swiperVideos.update();
            this.swiperVideos.attachEvents();
            this.swiperVideos.slideTo(initialSlide);
        }
    };
    Story.prototype.progressBarAdjustments = function () {
        var watchedStories = this.getFromLocalStorage('Teve2WatchedVideo-IDs');
        if (!watchedStories)
            return false;
        var allStoryCards = this.elements.storyCards.concat(this.elements.avatars);
        allStoryCards.forEach(function (el) {
            var progressEl = el.querySelector('.story-caption-wrapper');
            var videoId = el.getAttribute('data-video-id');
            var videoIdSet = el.getAttribute('data-video-id-set');
            if (videoId) {
                if (watchedStories.indexOf(videoId) > -1) {
                    progressEl.setAttribute('data-progress', '0');
                }
            }
            if (videoIdSet) {
                var idSetArr_1 = videoIdSet.split(',');
                var matches = watchedStories.filter(function (item) { return idSetArr_1.includes(item); });
                if (matches) {
                    progressEl.setAttribute('data-progress', parseInt((180 * ((idSetArr_1.length - matches.length) / idSetArr_1.length)).toString()));
                }
            }
        });
    };
    Story.prototype.avatarSetActiveAndScroll = function (slideToIndex) {
        var avatarsArray = Array.prototype.slice.call(this.elements.avatars);
        var targetAvatar = avatarsArray.filter(function (el) { return parseInt(el.getAttribute('data-target-slide')) === parseInt(slideToIndex); })[0];
        this.elements.avatars.forEach(function (avatar) {
            avatar.classList.remove('active');
        });
        if (targetAvatar) {
            targetAvatar.classList.add('active');
            targetAvatar.parentNode.scrollLeft = targetAvatar.offsetLeft - ((window.innerWidth - document.querySelector('.popup-story-videos .swiper-slide').offsetWidth) / 2);
        }
    };
    Story.prototype.avatarsClickHandler = function () {
        var _this = this;
        this.elements.avatars.forEach(function (avatar) {
            avatar.addEventListener('click', function () {
                var targetSlide = avatar.getAttribute('data-target-slide');
                if (_this.swiperVideos && targetSlide) {
                    for (var key in _this.swiperVideos.slides) {
                        if (!_this.swiperVideos.slides.hasOwnProperty(key))
                            continue;
                        if (_this.swiperVideos.slides[key].getAttribute('data-target-avatar') === targetSlide) {
                            _this.swiperVideos.slideTo(parseInt(_this.swiperVideos.slides[key].getAttribute('data-slide-index')) - 1);
                            break;
                        }
                    }
                }
            });
        });
    };
    Story.prototype.popupOpenClickHandler = function () {
        var popupCloseBtn = this.elements.popup.querySelector('.popup-story-close-btn');
        var popupStoryBgBlack = this.elements.popup.querySelector('.popup-story-bg-black');
        popupCloseBtn.addEventListener('click', this.closePopup.bind(this));
        popupStoryBgBlack.addEventListener('click', this.closePopup.bind(this));
    };
    Story.prototype.storyCardClickHandler = function () {
        var _this = this;
        this.elements.storyCards.forEach(function (storyCard) {
            storyCard.addEventListener('click', function (e) {
                e.preventDefault();
                var avatarIndex = storyCard.getAttribute('data-story-avatar');
                var subIndex = storyCard.getAttribute('data-story-subindex') !== '' ? storyCard.getAttribute('data-story-subindex') : 1;
                var initialSlide = parseInt(_this.elements.popup.querySelector('[data-target-avatar="' + avatarIndex + '"][data-avatar-subindex="' + subIndex + '"]').getAttribute('data-slide-index')) - 1;
                _this.elements.popup.style.display = 'block';
                document.querySelector('html').classList.add('story-popup-active');
                _this.initSwipers(initialSlide);
                _this.storyPlayer.play(_this.swiperVideos.slides[initialSlide]);
            });
        });
    };
    Story.prototype.closePopup = function () {
        this.elements.popup.style.display = "none";
        document.querySelector("html").classList.remove("story-popup-active");
        if (this.swiperVideos)
            this.swiperVideos.detachEvents();
    };
    Story.prototype.getFromLocalStorage = function (key) {
        return JSON.parse(localStorage.getItem(key));
    };
    return Story;
}());
var StoryPlayer = (function () {
    function StoryPlayer(endedCallback) {
        this.mediaRequestUrl = "/action/media/";
        this.videos = {};
        this.endedCallback = endedCallback;
    }
    StoryPlayer.prototype.play = function ($slide) {
        var $el = $slide.querySelector('.story-player');
        if ($el) {
            var videoId_1 = $el.getAttribute('id');
            if (typeof this.videos[videoId_1] === 'undefined') {
                // video daha önce init edilmedi, init edelim
                var options = {
                    id: videoId_1,
                    elementId: videoId_1,
                    category: '',
                    url: '',
                    tag: '',
                    pubname: '',
                    maincat: ''
                };
                this.createMediaServiceQuery(options, function (result) {
                    var _this = this;
                    if (result.status) {
                        var quarkPlayer_1 = this.createQuarkInstance(result.options);
                        quarkPlayer_1.adsActive = false;
                        quarkPlayer_1.adsInitialized = false;
                        quarkPlayer_1.endedListenerCalled = false;
                        this.videos[videoId_1] = quarkPlayer_1;
                        // slide container
                        var $slideContainer_1 = $($el).closest('.swiper-slide');
                        // popup container
                        var $popupContainer_1 = $($el).closest('.popup-story');
                        // pause control
                        quarkPlayer_1.player.on("timeupdate", function () {
                            // popup kapandı mı kontrolü
                            if ($popupContainer_1.is(':visible') === false) {
                                quarkPlayer_1.player.pause();
                            }
                            // slide aktif mi kontrolü
                            if ($slideContainer_1 &&
                                $slideContainer_1.hasClass('swiper-slide-active') === false) {
                                quarkPlayer_1.player.pause();
                            }
                        });
                        quarkPlayer_1.player.on("adsready", function () {
                            try {
                                quarkPlayer_1.adsInitialized = true;
                                var adsManager_1 = this.ima.getAdsManager();
                                adsManager_1.addEventListener(window.google.ima.AdEvent.Type.AD_PROGRESS, function (event) {
                                    // popup kapandı mı kontrolü
                                    if ($popupContainer_1.is(':visible') === false) {
                                        adsManager_1.pause();
                                    }
                                    // slide aktif mi kontrolü
                                    if ($slideContainer_1 &&
                                        $slideContainer_1.hasClass('swiper-slide-active') === false) {
                                        adsManager_1.pause();
                                    }
                                });
                                adsManager_1.addEventListener(window.google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED, function () {
                                    quarkPlayer_1.adsActive = false;
                                });
                                adsManager_1.addEventListener(window.google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED, function () {
                                    quarkPlayer_1.adsActive = true;
                                });
                            }
                            catch (ex) { }
                        });
                        var endedListener_1 = function () {
                            quarkPlayer_1.endedListenerCalled = true;
                            if (!quarkPlayer_1.adsInitialized) {
                                _this.endedCallback();
                            }
                            else {
                                var adsBeginCount_1 = 0;
                                var adsBeginMax_1 = 10;
                                var adsBeginInterval_1 = setInterval(function () {
                                    adsBeginCount_1++;
                                    if (adsBeginCount_1 >= adsBeginMax_1) {
                                        clearInterval(adsBeginInterval_1);
                                        _this.endedCallback();
                                    }
                                    else if (quarkPlayer_1.adsActive) {
                                        clearInterval(adsBeginInterval_1);
                                        var adsCompletedCount_1 = 0;
                                        var adsCompletedMax_1 = 300;
                                        var adsCompletedInterval_1 = setInterval(function () {
                                            adsCompletedCount_1++;
                                            if (adsCompletedCount_1 >= adsCompletedMax_1) {
                                                clearInterval(adsCompletedInterval_1);
                                                _this.endedCallback();
                                            }
                                            else {
                                                if (!quarkPlayer_1.adsActive) {
                                                    clearInterval(adsCompletedInterval_1);
                                                    _this.endedCallback();
                                                }
                                            }
                                        }, 200);
                                    }
                                }, 500);
                            }
                        };
                        quarkPlayer_1.player.on('ended', function () {
                            if (!quarkPlayer_1.endedListenerCalled) {
                                endedListener_1();
                            }
                        });
                        quarkPlayer_1.player.on('play', function () {
                            quarkPlayer_1.endedListenerCalled = false;
                        });
                    }
                    else {
                        console.log("Story player media service query error", result.message);
                    }
                }.bind(this));
            }
            else {
                if (this.videos[videoId_1].adsActive) {
                    try {
                        var adsManager = this.videos[videoId_1].player.ima.getAdsManager();
                        adsManager.resume();
                    }
                    catch (ex) { }
                }
                else {
                    this.videos[videoId_1].player.play();
                }
            }
        }
        else {
            console.log("Story player video element not founds");
        }
    };
    StoryPlayer.prototype.createMediaServiceQuery = function (options, callback) {
        var xhr = new Xhr();
        var requestUrl = this.mediaRequestUrl + options.id;
        xhr.getJSON(requestUrl, function (data) {
            if (data.Status === 'Success') {
                if (typeof data && data.Media && data.Media.Image !== 'undefined') {
                    options.poster = data.Media.Image + '.jpg';
                }
                else {
                    options.poster = '';
                }
                if (data.Media.Link.ServiceUrl) {
                    options.source = {
                        src: data.Media.Link.ServiceUrl + '/' + data.Media.Link.SecurePath,
                        type: 'application/x-mpegURL'
                    };
                }
                else {
                    options.source = {
                        src: (data.Media.Link.SecurePath.indexOf('http') > -1 ? '' : 'https://teve2.duhnet.tv') + (data.Media.Link.SecurePath.indexOf('/') === 0 || data.Media.Link.SecurePath.indexOf('http') > -1 ? data.Media.Link.SecurePath : '/' + data.Media.Link.SecurePath),
                        type: data.Media.Link.SecurePath.indexOf('.mp4') > -1 ? 'video/mp4' : 'application/x-mpegURL'
                    };
                }
                options.UserName = data.User.Name;
                options.SessionId = data.User.SessionId;
                callback({ status: true, options: options });
            }
            else {
                callback({ status: false, message: 'Something wrong' });
            }
        }, function () {
            callback({ status: false, message: 'Something wrong' });
        });
    };
    StoryPlayer.prototype.createQuarkInstance = function (elementOptions) {
        var options = {
            id: elementOptions.elementId,
            materialId: elementOptions.id,
            debug: false,
            techOrder: ['html5'],
            autoPlay: true,
            viewability: false,
            showAds: true,
            embedUrl: location.protocol + '//' + location.host + '/embed' + elementOptions.url,
            url: location.protocol + '//' + location.host + elementOptions.url,
            contentId: elementOptions.id,
            category: elementOptions.category,
            tag: elementOptions.tag,
            pubname: elementOptions.pubname,
            maincat: elementOptions.maincat,
            playtype: '',
            isSpotVideo: '',
            showNotification: false,
            showBandwidthSelector: true,
            customMenu: true,
            live: false,
            poster: '',
            sources: [elementOptions.source],
            subTitles: null,
            playsinline: true,
            // Birden çok targetı bir arada kullanabilmek için VMAP kullanılmalıdır. VMAP açıklamasına dökümandan ulaşılabilir
            adTagUrl: window.location.origin + '/action/vmap?id=' + elementOptions.id + "&plcmt=1",
            plugins: [],
            stats: {
                gemius: {
                    identifier: "dw.q8cb623JEXnnyE2dkL6PeHUvu8Ucmwu8LvtsUIzD.47"
                },
                comscore: {
                    c1: "1",
                    c2: "9053247",
                    c3: "TV2"
                }
            }
        };
        return new QuarkPlayer(options);
    };
    return StoryPlayer;
}());
new Story();
/// <reference path="typings/swiper.d.ts" />
/// <reference path="typings/jquery.d.ts" />
/**
 * Thumbnail objesi oluşturmaya yarar. Site içerisinde herhangi bir sayfadaki thumbnailler bu class üzerinden oluşturulmaktadır.
 * @class SwiperObjects
 */
var SwiperObjects = (function () {
    /**
     * @memberOf SwiperObjects
     * @method constructor
     * @desc {@link SwiperObjects} oluşturulduğunda otomatik olarak document içerisinde
     * thumbnail-slider-container class isimlendirmesini içeren elementleri thumbnailSliders değişkeni içerisine atar.
     */
    function SwiperObjects() {
        this.thumbnailSliders = document.querySelectorAll('.thumbnail-slider-container[class*="swiper-"]');
        this.sliderSection = document.getElementById('schedule');
        if (this.sliderSection) {
            this.daysArray = [
                { "dayID": "#pazartesi", "dayName": "Pazartesi" },
                { "dayID": "#sali", "dayName": "Salı" },
                { "dayID": "#carsamba", "dayName": "Çarşamba" },
                { "dayID": "#persembe", "dayName": "Perşembe" },
                { "dayID": "#cuma", "dayName": "Cuma" },
                { "dayID": "#cumartesi", "dayName": "Cumartesi" },
                { "dayID": "#pazar", "dayName": "Pazar" }
            ];
            this.prevDayNode = document.getElementById('prevDaySwiper');
            this.nextDayNode = document.getElementById('nextDaySwiper');
            this.createScheduleSlider();
        }
    }
    SwiperObjects.prototype.createScheduleSlider = function () {
        var scheduleSwiper = new Swiper('.swiper-schedule', {
            nextButton: '.swiper-button-next',
            prevButton: '.swiper-button-prev',
            loop: false
        });
        var currentIndex = scheduleSwiper.activeIndex;
        this.updateSchedulePaginationNames(currentIndex);
        var dayTabs = document.getElementsByClassName('tab-pane');
        var _this = this;
        Object.keys(dayTabs).forEach(function (key) {
            if (dayTabs[key].classList.contains('active')) {
                if (key.length === 1) {
                    _this.activeDayIndex = key;
                }
            }
        });
        scheduleSwiper.slideTo(this.activeDayIndex);
        this.setScheduleListener(scheduleSwiper);
    };
    SwiperObjects.prototype.setScheduleListener = function (scheduleSwiper) {
        var _this = this;
        scheduleSwiper.on('slideChangeEnd', function () {
            var currentIndex = scheduleSwiper.activeIndex;
            _this.updateSchedulePaginationNames(currentIndex);
            var tabObject = '#schedule a[href="' + _this.daysArray[currentIndex].dayID + '"]';
            $(tabObject).tab('show');
        });
    };
    SwiperObjects.prototype.updateSchedulePaginationNames = function (currentIndex) {
        var _this = this;
        if (currentIndex === 0) {
            _this.prevDayNode.textContent = "";
            _this.nextDayNode.textContent = _this.daysArray[(currentIndex + 1)].dayName;
        }
        else if (currentIndex === 6) {
            _this.nextDayNode.textContent = "";
            _this.prevDayNode.textContent = _this.daysArray[(currentIndex - 1)].dayName;
        }
        else {
            _this.prevDayNode.textContent = _this.daysArray[(currentIndex - 1)].dayName;
            _this.nextDayNode.textContent = _this.daysArray[(currentIndex + 1)].dayName;
        }
    };
    /**
     * @memberOf SwiperObjects
     * @desc Anasayfa slider elementinin oluşturulmasını sağlar.
     */
    SwiperObjects.prototype.createHomeSlider = function () {
        new Swiper('.home-slider-container', {
            nextButton: '.slider-next',
            prevButton: '.slider-prev',
            loop: true,
            slidesPerView: 1,
            centeredSlides: true,
            freeMode: false,
            pagination: '.slider-pagination',
            paginationClickable: true,
            autoplay: 14000,
            autoplayDisableOnInteraction: false
        });
    };
    /**
     * @memberOf SwiperObjects
     * @desc Bu fonksiyon Thumbnail objelerinin dinamik olarak oluşturulmasını sağlamaktadır.
     * Bu şekilde kaç adet swiper objesi varsa bunlar için ilgili parametreler oluşturulmaktadır.
     * İlgili parametreleri alarak {@link SwiperObjects#createThumbnail} fonksiyonunu çağırmaktadır.
     */
    SwiperObjects.prototype.getThumbnailObjects = function () {
        var _this = this;
        var thumbnailSliders = _this.thumbnailSliders;
        if (thumbnailSliders.length !== 0 && thumbnailSliders[0].classList[2]) {
            Object.keys(thumbnailSliders).forEach(function (key) {
                var funcNumbers = thumbnailSliders[key].classList[2].match(/\d/g);
                var type = parseInt(funcNumbers[0]);
                var slidesView = parseInt(funcNumbers[1]);
                var ID = parseInt(funcNumbers[2]);
                _this.createThumbnail(type, slidesView, ID);
            });
        }
    };
    /**
     * @memberOf SwiperObjects
     * @desc Thumbnail objeleri ilgili class üzerinden alındıktan sonra gelen tipine göre
     * dinamik olarak elementin oluşturulması sağlanır.
     *
     * @param {number} type - Sliderin tipinin ne olduğunu belirtir. Bu sayede tablet ve mobil ekran görüntülenecek slider sayıları belirlenmiş olur
     * <b>type 1;</b>
     * mobil Slider sayısı = 2.5
     * tablet Slider sayısı = 3
     * <b>type 2;</b>
     * mobil Slider sayısı = 1.25
     * tablet Slider sayısı = 3
     * <b>type 3;</b>
     * mobil Slider sayısı = 1.25
     * tablet Slider sayısı = 2
     *
     * @param {number} slidesView - Desktop görünümünde kaç adet slider görüntüleneceğini belirtir
     * @param {number} ID - Swiper elementlerinin bağımsız olarak tanımlanması için rastgele bir değer verilerek oluşturulan parametredir.
     */
    SwiperObjects.prototype.createThumbnail = function (type, slidesView, ID) {
        var mobileView;
        var tabletView;
        var slidesPerColumnDesktop;
        var slidesPerColumnMobile;
        switch (type) {
            case 1:
                mobileView = 2.5;
                tabletView = 3;
                slidesPerColumnDesktop = 1;
                slidesPerColumnMobile = 1;
                break;
            case 2:
                mobileView = 1.25;
                tabletView = 3;
                slidesPerColumnDesktop = 1;
                slidesPerColumnMobile = 1;
                break;
            case 3:
                mobileView = 1.25;
                tabletView = 2;
                slidesPerColumnDesktop = 1;
                slidesPerColumnMobile = 1;
                break;
            case 4:
                mobileView = 2.25;
                tabletView = 4;
                slidesPerColumnDesktop = 2;
                slidesPerColumnMobile = 1;
                break;
        }
        new Swiper('.swiper-' + type + '-' + slidesView + '-' + ID, {
            slidesPerView: slidesView,
            slidesPerColumn: slidesPerColumnDesktop,
            spaceBetween: 16,
            pagination: '.swiper-pagination',
            nextButton: '.swiper-button-next',
            prevButton: '.swiper-button-prev',
            slidesPerGroup: slidesView,
            freeMode: false,
            paginationClickable: true,
            simulateTouch: false,
            slidesPerColumnFill: 'row',
            breakpoints: {
                992: {
                    slidesPerView: tabletView,
                    simulateTouch: false,
                    slidesPerColumn: slidesPerColumnMobile
                },
                758: {
                    slidesPerView: mobileView,
                    simulateTouch: true,
                    freeMode: true,
                    slidesPerColumn: slidesPerColumnMobile
                }
            }
        });
    };
    return SwiperObjects;
}());
var swiperElements = new SwiperObjects();
swiperElements.createHomeSlider();
swiperElements.getThumbnailObjects();
/// <reference path="typings/jquery.d.ts" />
/// <reference path="typings/quarkplayer.d.ts" />
/// <reference path="commons/xhr.ts" />
/// <reference path="commons/cookie.ts" />
var WhichOne = (function () {
    function WhichOne() {
        this.setKey = false;
        this.containers = {
            competition: document.querySelector(".which-one"),
            step: document.querySelector(".which-one-step"),
            stepOption1: document.querySelector(".which-one-step .wo-option.option-1"),
            stepOption2: document.querySelector(".which-one-step .wo-option.option-2"),
            infoRow: document.querySelector(".which-one-info"),
            answered: document.querySelector(".which-one-answered"),
            before: document.querySelector(".which-one-item-wrapper"),
            beforeFigure1: document.querySelector(".which-one-item .wo-option.option-1"),
            beforeFigure2: document.querySelector(".which-one-item .wo-option.option-2"),
            headToHead: document.querySelectorAll(".head-to-head"),
            widget: document.querySelector(".which-one-widget")
        };
        if (this.containers.competition) {
            this.elements = {
                question: this.containers.competition.querySelector(".which-one-title"),
                step: {
                    option1: {
                        input: this.containers.stepOption1.querySelector("input"),
                        label: this.containers.stepOption1.querySelector("label"),
                        figure: this.containers.stepOption1.querySelector(".wo-figure"),
                        title: this.containers.stepOption1.querySelector(".title"),
                        voteCount: this.containers.stepOption1.querySelector(".wo-vote-count"),
                        votePercent: this.containers.stepOption1.querySelector(".wo-vote-percent")
                    },
                    option2: {
                        input: this.containers.stepOption2.querySelector("input"),
                        label: this.containers.stepOption2.querySelector("label"),
                        figure: this.containers.stepOption2.querySelector(".wo-figure"),
                        title: this.containers.stepOption2.querySelector(".title"),
                        voteCount: this.containers.stepOption2.querySelector(".wo-vote-count"),
                        votePercent: this.containers.stepOption2.querySelector(".wo-vote-percent")
                    }
                },
                before: {
                    figure1: {
                        figure: this.containers.beforeFigure1.querySelector("img"),
                        title: this.containers.beforeFigure1.querySelector(".title"),
                        voteCount: this.containers.beforeFigure1.querySelector(".wo-vote-count"),
                        votePercent: this.containers.beforeFigure1.querySelector(".wo-vote-percent")
                    },
                    figure2: {
                        figure: this.containers.beforeFigure2.querySelector("img"),
                        title: this.containers.beforeFigure2.querySelector(".title"),
                        voteCount: this.containers.beforeFigure2.querySelector(".wo-vote-count"),
                        votePercent: this.containers.beforeFigure2.querySelector(".wo-vote-percent")
                    },
                    title: this.containers.before.querySelector(".wo-title")
                }
            };
            this.formId = this.containers.competition.getAttribute("data-id");
            this.formUrl = this.containers.competition.getAttribute("data-url");
            this.formPageId = this.containers.competition.getAttribute("data-page-id");
            this.imageUrl = this.containers.competition.getAttribute("data-image-url");
        }
        this.init();
    }
    WhichOne.prototype.init = function () {
        var _this = this;
        if (this.containers.widget) {
            var widgetRadios = this.containers.widget.querySelectorAll("input[type='radio']");
            widgetRadios.forEach(function (radio) {
                radio.addEventListener("change", function () {
                    _this.stepControl("widgetchoice", radio);
                });
            });
            this.containers.widget.querySelector(".wo-skip").addEventListener("click", function () {
                window.location.href = _this.containers.widget.getAttribute("data-url");
            });
        }
        if (!this.containers.competition) {
            return false;
        }
        var url = "/action/contest_which_questions/" + this.formId;
        if (this.formPageId) {
            url += "?pageId=" + this.formPageId;
        }
        if (this.formId) {
            this.createData(url);
        }
        var radios = this.containers.step.querySelectorAll("input[type='radio']");
        radios.forEach(function (radio) {
            radio.addEventListener("change", function () {
                _this.stepControl("choice", radio);
            });
        });
        this.containers.infoRow.querySelector(".wo-skip").addEventListener("click", function () {
            _this.stepControl("skip");
        });
        this.containers.answered.querySelector(".skip").addEventListener("click", function () {
            _this.stepControl("skip");
        });
        if (this.containers.headToHead.length > 0) {
            this.containers.headToHead.forEach(function (headToHead) {
                headToHead.querySelectorAll(".head-to-head-item").forEach(function (item) {
                    item.addEventListener("click", function (e) {
                        e.preventDefault();
                        var questionId = item.getAttribute("data-id");
                        var parent = item.closest(".head-to-head");
                        if (parent.hasAttribute("data-title")) {
                            var url_1 = _this.formUrl + "?page=" + parent.getAttribute("data-title");
                            if (questionId) {
                                url_1 += "#" + questionId;
                            }
                            window.location.href = url_1;
                            return;
                        }
                        if (questionId) {
                            _this.stepControl("goto", null, questionId);
                        }
                    });
                });
            });
        }
    };
    WhichOne.prototype.stepControl = function (eventType, element, questionId) {
        if (element === void 0) { element = null; }
        if (questionId === void 0) { questionId = null; }
        if (eventType === "widgetchoice") {
            this.nextScreen(element, true);
            return;
        }
        this.containers.competition.classList.remove("step");
        this.containers.competition.classList.remove("answered");
        this.containers.competition.classList.remove("final");
        if (eventType === "choice") {
            this.nextScreen(element);
        }
        if (eventType === "skip") {
            this.skipScreen();
        }
        if (eventType === "goto") {
            this.gotoScreen(questionId);
        }
    };
    WhichOne.prototype.nextScreen = function (element, widget) {
        var _this = this;
        if (widget === void 0) { widget = false; }
        if (!widget) {
            this.containers.before.classList.add("visible");
            this.containers.competition.classList.remove("before");
        }
        var choiceId = element.value;
        var questionId = element.name;
        var cookie = Cookie.getCookie("contestWhich");
        var timestamp = new Date();
        var time = timestamp.getTime();
        time += 60 * 60 * 24 * 365 * 1000;
        timestamp.setTime(time);
        if (cookie) {
            var cookieArr = cookie.split(',');
            if (cookieArr.indexOf(questionId) === -1) {
                cookieArr.push(questionId);
                cookie = cookieArr.join(',');
                document.cookie = 'contestWhich=' + cookie + '; expires=' + timestamp.toUTCString() + '; path=/';
            }
        }
        else {
            document.cookie = 'contestWhich=' + questionId + '; expires=' + timestamp.toUTCString() + '; path=/';
        }
        var postData = {
            choiceId: choiceId,
            id: widget ? this.containers.widget.getAttribute("data-form-id") : this.formId,
            questionId: questionId
        };
        var url = "/action/contest_which";
        this.postData(url, postData).then(function (data) {
            if (widget) {
                window.location.href = _this.containers.widget.getAttribute("data-url");
                return;
            }
            if (data) {
                element.checked = false;
                _this.setBeforeData(data);
            }
        });
        if (!widget) {
            this.setStepData();
        }
    };
    WhichOne.prototype.skipScreen = function () {
        this.setStepData();
    };
    WhichOne.prototype.gotoScreen = function (questionId) {
        var offset = this.containers.competition.offsetTop;
        if (window.innerWidth < 768) {
            offset -= document.querySelector(".navbar").scrollHeight;
        }
        else {
            offset -= 25;
        }
        window.scrollTo({ top: offset, behavior: "smooth" });
        this.setStepData(questionId);
    };
    WhichOne.prototype.getData = function (url) {
        return $.ajax({
            type: "GET",
            url: url,
            dataType: "json"
        }).then(function (data) {
            return data;
        }).fail(function (jqXHR, textStatus, errorThrown) {
            console.error("Error: ", errorThrown);
        });
    };
    WhichOne.prototype.postData = function (url, postData) {
        return $.ajax({
            type: "POST",
            url: url,
            data: JSON.stringify(postData),
            dataType: "json"
        }).then(function (data) {
            return data;
        }).fail(function (jqXHR, textStatus, errorThrown) {
            console.error("Error: ", errorThrown);
        });
    };
    WhichOne.prototype.createData = function (url) {
        var _this = this;
        this.getData(url).then(function (data) {
            if (!data) {
                console.error("data: ", data);
                return false;
            }
            _this.data = data;
            var questionId = null;
            var hash = window.location.hash;
            if (hash) {
                var hashQuestion_1 = hash.replace("#", "");
                var question = _this.data.find(function (item) {
                    return item.id == hashQuestion_1;
                });
                if (question) {
                    questionId = question.id;
                }
            }
            _this.setStepData(questionId);
            var cookie = Cookie.getCookie("contestWhich");
            var answeredQuestions = cookie ? cookie.split(',') : [];
            if (answeredQuestions.length > 0) {
                // get last answered question
                var lastQuestionId_1 = answeredQuestions[answeredQuestions.length - 1];
                var lastQuestion = _this.data.find(function (item) {
                    return item.id == lastQuestionId_1;
                });
                if (lastQuestion) {
                    _this.containers.before.classList.add("visible");
                    _this.setBeforeData(lastQuestion);
                }
            }
        });
    };
    WhichOne.prototype.setStepData = function (questionId) {
        var _this = this;
        if (questionId === void 0) { questionId = null; }
        var dataIndex = 0;
        var cookie = Cookie.getCookie("contestWhich");
        var answeredQuestions = cookie ? cookie.split(',') : [];
        var allAnswered = false;
        var answered = false;
        if (questionId) {
            if (answeredQuestions.indexOf(questionId) === -1) {
                dataIndex = this.data.findIndex(function (item) {
                    return item.id == questionId;
                });
            }
            else {
                answered = true;
            }
        }
        else {
            var unansweredQuestions = this.data.filter(function (item) {
                return answeredQuestions.indexOf(item.id) === -1;
            });
            if (unansweredQuestions.length > 0) {
                var randomIndex = Math.floor(Math.random() * unansweredQuestions.length);
                var randomQuestion_1 = unansweredQuestions[randomIndex];
                dataIndex = this.data.findIndex(function (item) {
                    return item.id == randomQuestion_1.id;
                });
            }
            else {
                allAnswered = true;
            }
        }
        if (allAnswered) {
            this.containers.competition.classList.remove("step");
            this.containers.competition.classList.remove("answered");
            this.containers.competition.classList.add("final");
            return;
        }
        if (answered) {
            this.containers.competition.classList.remove("step");
            this.containers.competition.classList.remove("final");
            this.containers.competition.classList.add("answered");
            return;
        }
        var imgBaseUrl = this.imageUrl + "/400x0/";
        this.elements.question.innerText = this.data[dataIndex].title;
        this.elements.step.option1.input.name = this.data[dataIndex].id;
        this.elements.step.option1.input.value = this.data[dataIndex].choices[0].id;
        this.elements.step.option1.input.id = this.data[dataIndex].choices[0].id;
        this.elements.step.option1.label.htmlFor = this.data[dataIndex].choices[0].id;
        this.elements.step.option1.figure.style.background = "url(" + imgBaseUrl + this.data[dataIndex].choices[0].file + ") center center / cover no-repeat";
        this.elements.step.option1.title.innerText = this.data[dataIndex].choices[0].title;
        this.elements.step.option1.voteCount.innerText = this.data[dataIndex].choices[0].answerCount + " Oy";
        this.elements.step.option1.votePercent.innerText = "%" + this.data[dataIndex].choices[0].answerPercent;
        this.elements.step.option2.input.name = this.data[dataIndex].id;
        this.elements.step.option2.input.value = this.data[dataIndex].choices[1].id;
        this.elements.step.option2.input.id = this.data[dataIndex].choices[1].id;
        this.elements.step.option2.label.htmlFor = this.data[dataIndex].choices[1].id;
        this.elements.step.option2.figure.style.background = "url(" + imgBaseUrl + this.data[dataIndex].choices[1].file + ") center center / cover no-repeat";
        this.elements.step.option2.title.innerText = this.data[dataIndex].choices[1].title;
        this.elements.step.option2.voteCount.innerText = this.data[dataIndex].choices[1].answerCount + " Oy";
        this.elements.step.option2.votePercent.innerText = "%" + this.data[dataIndex].choices[1].answerPercent;
        if (!this.setKey) {
            this.containers.competition.classList.add("step");
            this.setKey = true;
            return;
        }
        setTimeout(function () {
            _this.containers.competition.classList.add("step");
        }, 500);
    };
    WhichOne.prototype.setBeforeData = function (data) {
        var _this = this;
        var imgBaseUrl = this.imageUrl + "/355x416/";
        this.elements.before.figure1.figure.src = imgBaseUrl + data.choices[0].file;
        this.elements.before.figure1.figure.alt = data.choices[0].title;
        this.elements.before.figure1.title.innerText = data.choices[0].title;
        this.elements.before.figure1.voteCount.innerText = data.choices[0].answerCount + " Oy";
        this.elements.before.figure1.votePercent.innerText = "%" + data.choices[0].answerPercent;
        this.elements.before.figure2.figure.src = imgBaseUrl + data.choices[1].file;
        this.elements.before.figure2.figure.alt = data.choices[1].title;
        this.elements.before.figure2.title.innerText = data.choices[1].title;
        this.elements.before.figure2.voteCount.innerText = data.choices[1].answerCount + " Oy";
        this.elements.before.figure2.votePercent.innerText = "%" + data.choices[1].answerPercent;
        this.elements.before.title.innerText = data.title;
        setTimeout(function () {
            _this.containers.competition.classList.add("before");
        }, 300);
    };
    return WhichOne;
}());
var whicOne = new WhichOne();
//# sourceMappingURL=docs.js.map